import axios from 'axios'
// import { MessageBox, Message } from 'element-ui'
// import store from '@/store/index'
// import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    // baseURL: "http://iot.kirincs.com/printer/iot-web-pro/",  // url = base url + request url
    timeout: 10000 // request timeout
})

// 请求拦截
service.interceptors.request.use(

)

// 响应拦截
service.interceptors.response.use(

    response => {
        const res = response
        if (res.status == 200) {
            if (res.data.code == 0 || res.data.code == undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.reject(res.data)
            }
        } else {
            if (res.data == null || res.data == undefined) {
                return Promise.reject(res.msg || 'Error')
            } else {
                return res
            }
        }
    },

    error => {
        return Promise.reject(error)
    }
)

export default service